import React from 'react'
import ContentLoader from 'react-content-loader'

import styles from './index.module.scss'

export default function Skeleton() {
  return (
    <div className={styles.container}>
      <ContentLoader viewBox="0 0 400 880" backgroundColor="#f5f7fa">
        <rect x="0" y="0" width="500" height="200" />
        <rect x="0" y="220" width="500" height="200" />
        <rect x="0" y="440" width="500" height="200" />
        <rect x="0" y="660" width="500" height="200" />
      </ContentLoader>
    </div>
  )
}
